import { Progress } from 'flowbite-react';
import React from 'react';
import { Img } from 'react-image';

type Props = {
	bannerData: {
		streak: number;
		progress: number;
	};
	numberOfDays: number;
};

const PrepareBanner = ({ bannerData, numberOfDays }: Props) => {
	return (
		<div className="bg-white dark:bg-[#1F2A37]">
			<div className="max-w-[1440px] mx-auto bg-white dark:bg-[#1F2A37] flex flex-col overflow-hidden relative p-4 md:px-28 md:py-6">
				<div className="w-[calc(100%-140px)] md:max-w-[500px] ">
					<p className="text-left font-medium text-lg font-inter dark:text-[#FFF] md:text-xl md:font-semibold md:leading-6	">
						Your Career Path
					</p>

					<p className="text-[#7777E7] dark:text-[#CDF] text-xs font-inter font-normal mt-2 md:text-base	">
						Get job-ready with our personalised path. Unlock <span className="greenish-gradient-text">FREE</span> round
						2 after Day {numberOfDays}. Your dream tech role awaits!
					</p>
				</div>
				<div className="mt-5 text-gray-600 dark:text-[#C7C9D9] text-xs leading-[10px] md:text-base md:leading-[10px] ">
					<p>Overall Progress</p>
				</div>
				<div className="mt-[0.5px] z-10 md:max-w-[500px] ">
					<p className="text-right font-medium text-xs font-inter text-[#7777E7] md:text-base md:leading-[10px]">{`${bannerData.progress}%`}</p>

					<Progress
						progress={bannerData.progress}
						color="purplePlaced"
						className="prepare-banner-progress-bar rounded-[8px] progress-bar md:mt-2 "
					/>
				</div>
				<Img
					src="/assets/personalisedPathBanner.svg"
					alt="personalisedPathBanner"
					className="absolute top-0 right-0 w-[140px] h-[143px] md:w-[171px] md:h-[171px] md:right-28 hidden dark:block"
				/>
				<Img
					src="/assets/prepPlanIllustrationLight.svg"
					alt="personalisedPathBanner"
					className="absolute top-0 right-0 w-[140px] h-[143px] md:w-[171px] md:h-[171px] md:right-28 block dark:hidden"
				/>
			</div>
		</div>
	);
};

export default PrepareBanner;
